import { render, staticRenderFns } from "./SyText.vue?vue&type=template&id=5684c87b&scoped=true&"
import script from "./SyText.vue?vue&type=script&lang=ts&"
export * from "./SyText.vue?vue&type=script&lang=ts&"
import style0 from "./SyText.vue?vue&type=style&index=0&id=5684c87b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5684c87b",
  null
  
)

export default component.exports